import { $http } from "@/assets/js/appFunc";

export const getUIList = (context) => {
    if (context.state.uiList.length === 0) {
        const req = {
            type: "GET",
            url: "/admin/allGui/versionId/e0216c9a-6f81-4d12-93f2-8b5f9bd2c2a6",
            data: null
        };
        $http(req).then(
            data => context.commit("setUIList", data),
            error => console.log(error)
        );
    }
};

export const deleteUI = (context, ui) => {
    delete ui.__index;
    const req = {
        type: "DELETE",
        url: `/gui/${ui.id}`,
        data: null
    };
    $http(req).then(
        data => context.commit("deleteUI", ui),
        error => console.log(error)
    );
};
